import { ApiKey } from "../apiKeys";
import { authAxios } from "../config";
import { AllTransactionType } from "../../types/paymentTypes";
import { checkTokenValidation } from "../auth/tokenReq";

export const getDashboardStatsReq = async () => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": dashboardStatsReq->getDashboardStatsReq " + t
    );
  try {
    await checkTokenValidation();

    const res = await authAxios.get(`${ApiKey.dashboardStatsKey}`);
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = res?.data?.message || "";
    const _data = {
      numberOfCandidateOffers: resData?.numberOfCandidateOffers || "0",
      numberOfCandidates: resData?.numberOfCandidates || "0",
      numberOfCompanies: resData?.numberOfCompanies || "0",
      numberofCardsets: resData?.numberofCardsets || "0",
      joinedCandidatesCount: resData?.joinedCandidatesCount || "0",
      joinersPercentage: resData?.joinersPercentage || "0",
      dropoutCandidatesCount: resData?.dropoutCandidatesCount || "0",
      dropoutPercentage: resData?.dropoutPercentage || "0",
      currentMonthTransactions: resData?.currentMonthTransactions?.map(
        (item: AllTransactionType) => ({
          month: item?.month || "",
          year: item?.year || "",
          totalAmount: item?.totalAmount || "0",
        })
      ),
    };
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};
